import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-termos-condicoes-mt',
  templateUrl: './termos-condicoes-mt.component.html',
  styleUrls: ['./termos-condicoes-mt.component.scss']
})
export class TermosCondicoesMTComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
